__turbopack_context__.v({
  "shimmer": "Shimmer-module__ANjrwa__shimmer",
  "shimmerNormal": "Shimmer-module__ANjrwa__shimmerNormal",
  "shimmerRound": "Shimmer-module__ANjrwa__shimmerRound",
  "shimmerRounded": "Shimmer-module__ANjrwa__shimmerRounded",
});
